module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$d(_vm.item.date, 'long')))])]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v(_vm._s(_vm.$t("message.start")) + ": " + _vm._s(_vm._f("moment")(_vm.item.start, "HH:mm a")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.end")) + ": " + _vm._s(_vm._f("moment")(_vm.item.end, "HH:mm a")))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.hours")) + ": " + _vm._s(_vm.item.lapse))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.income")) + ": " + _vm._s(_vm.$n(_vm.item.income, 'currency')))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "success": "",
      "to": {
        name: 'Edit',
        params: {
          id: this.id
        }
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("edit")]), _vm._v("\n            " + _vm._s(_vm.$t("message.buttons.edit")) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "error": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteItem()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("delete")]), _vm._v("\n            " + _vm._s(_vm.$t("message.buttons.delete")) + "\n        ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60be7b64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View.vue
// module id = 235
// module chunks = 1